import React, { useState, useEffect, useRef }  from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import QueuedPostRequest from 'components/layout_and_quote_builder/utils/QueuedPostRequest.js';
import { getFromCache, setInCache, hasInCache } from 'components/layout_and_quote_builder/utils/SolutionScoreCache.js';
// import LayoutNavSectionCombinationImg from 'components/layout_and_quote_builder/LayoutNavSectionCombinationImg.jsx'
import LayoutSvg from 'components/layout_and_quote_builder/quote_builder/LayoutSvg.jsx'
import SolutionJsonViewer from 'components/layout_and_quote_builder/SolutionJsonViewer.jsx'

const LayoutNavSectionCombination = ( { diecutting_result, nav_section_id, count, layout_dimension, setTotalScoreList, index , setNumTotals, setNumTotalsPrinting, setNumOfDrawingsInSet} ) => {
  const name = `${diecutting_result.uuid}`;
  // Helper function to format dimensions - removes .0 for whole numbers
  const formatDimension = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    // If it's a whole number, show without decimals
    return num % 1 === 0 ? num.toFixed(0) : num.toString();
  };

  const [cuttingScore, setCuttingScore] = useState( 0 )
  const [printingScore, setPrintingScore] = useState( 0 )
  const [materialScore, setMaterialScore] = useState( 0 )
  const [kesim_num_total, set_kesim_num_total] = useState( 0 )
  const [print_num_total, set_print_num_total] = useState( 0 )

  const [score, setScore] = useState( 0 )
  const [printingImageUrl, setPrintingImageUrl] = useState( '')
  const [diecuttingImageUrl, setDiecuttingImageUrl] = useState( '')
  const [numTotal, setNumTotal] = useState(0);
  const [numOfDrawingInSet, setNumOfDrawingInSet] = useState(1);
  const [efficiency, setEfficiency] = useState(null);

  const [partTypes, setPartTypes] = useState([])
  // The whole score response, kept verbatim so the admin JSON viewer can show exactly what the card was built from.
  const [scoreData, setScoreData] = useState(null);
  const requestInFlightRef = useRef(false);
  const [calculated_output_dimensions, set_calculated_output_dimensions] = useState("")

  const [cuttingMachineLayoutDimensionsInMmWidth, setCuttingMachineLayoutDimensionsInMmWidth] = useState(0)
  const [cuttingMachineLayoutDimensionsInMmHeight, setCuttingMachineLayoutDimensionsInMmHeight] = useState(0)
  const [printingMachineLayoutDimensionInMmWidth, setPrintingMachineLayoutDimensionInMmWidth] = useState(0)
  const [printingMachineLayoutDimensionInMmHeight, setPrintingMachineLayoutDimensionInMmHeight] = useState(0)

  const [cutting_machine_found, set_cutting_machine_found] = useState(false);
  const [printing_machine_found, set_printing_machine_found] = useState(false);
  const [dieCuttingMachineIdentifier, setDieCuttingMachineIdentifier] = useState(null);

  // Apply score data to component state
  const applyScoreData = (data) => {
    setScoreData(() => data);
    setScore(() => data.score);
    setNumTotal(() => data.diecutting_num_total);
    set_cutting_machine_found(() => data.cutting_machine_found);
    set_printing_machine_found(() => data.printing_machine_found);
    setNumOfDrawingInSet(() => data.num_of_drawings_in_set);
    setPrintingImageUrl(() => data.printing_result_image_url);
    setDiecuttingImageUrl(() => data.diecutting_result_image_url);
    setEfficiency(() => data.efficiency);

    setCuttingScore(() => data._score_debug.cutting);
    setPrintingScore(() => data._score_debug.printing);
    setMaterialScore(() => data._score_debug.material);
    set_kesim_num_total(() => data._score_debug.kesim_num_total);
    set_print_num_total(() => data._score_debug.print_num_total);

    setCuttingMachineLayoutDimensionsInMmWidth(() => data.cutting_machine_layout_dimensions_in_mm?.width);
    setCuttingMachineLayoutDimensionsInMmHeight(() => data.cutting_machine_layout_dimensions_in_mm?.height);

    setPrintingMachineLayoutDimensionInMmWidth(() => data.printing_machine_layout_dimension_in_mm?.width);
    setPrintingMachineLayoutDimensionInMmHeight(() => data.printing_machine_layout_dimension_in_mm?.height);

    setDieCuttingMachineIdentifier(() => data.die_cutting_machine_identifier);

    set_calculated_output_dimensions(() => {
      const dimensions = data.calculated_output_dimensions;
      if (!dimensions?.output_x_length || !dimensions?.output_y_length) {
        return "";
      }
      const xLength = parseFloat(dimensions.output_x_length);
      const yLength = parseFloat(dimensions.output_y_length);
      if (isNaN(xLength) || isNaN(yLength)) {
        return "";
      }
      return xLength.toFixed(2) + " x " + yLength.toFixed(2);
    });

    setNumTotals((prev) => {
      return {
        ...prev,
        [index]: data.diecutting_num_total,
      };
    });

    setNumTotalsPrinting((prev) => {
      return {
        ...prev,
        [index]: data.printing_num_total,
      };
    });

    setNumOfDrawingsInSet((prev) => {
      return {
        ...prev,
        [index]: data.num_of_drawings_in_set,
      };
    });
  };

  const getScore = () => {
    if (score > 0) { return; }
    if (requestInFlightRef.current) { return; }

    const uuid = diecutting_result.uuid;

    // Check cache first - prevents duplicate API calls for same solution
    if (hasInCache(uuid)) {
      const cachedData = getFromCache(uuid);
      applyScoreData(cachedData);
      return;
    }

    requestInFlightRef.current = true;

    QueuedPostRequest({
      url: `/layouts-nav-section-combination-score`,
      data: {
        formula_options: window.dielineOptions,
        diecutting_result: diecutting_result,
        nav_section_id: nav_section_id,
        count: count,
        id: window.drawingId,
        layout_dimension_id: layout_dimension.id
      },
      callback: (data) => {
        // Cache the response for reuse
        setInCache(uuid, data);
        applyScoreData(data);
        requestInFlightRef.current = false;
      }
    }).catch((error) => {
      console.error('[LayoutNavSectionCombination getScore] Unhandled error:', error);
      requestInFlightRef.current = false;
    });
  }

  useEffect(() => {
    setTotalScoreList(prev => ({
      ...prev,
      [index]: score,
    }));
  }, [score]);

  const ENTER_EDGE = '#eb5424';
  const toDisplayMm = (valueMm) => (
    window.user_unit == 'in'
      ? `${formatDimension((parseFloat(valueMm) / 25.4).toFixed(2))}in`
      : `${formatDimension(valueMm)}mm`
  );
  // A labeled rectangle: width along the bottom edge, height up the left edge — the same treatment for the
  // material and the machine.
  const labeledRect = ({ widthMm, heightMm, widthPx, heightPx, borderColor, background, children }) => (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <div style={{ fontSize: '11px', color: '#777', lineHeight: 1, writingMode: 'vertical-rl', transform: 'rotate(180deg)', textAlign: 'center', height: `${heightPx}px`, marginRight: '3px' }}>{toDisplayMm(heightMm)}</div>
      <div style={{
        position: 'relative', width: `${widthPx}px`, height: `${heightPx}px`, boxSizing: 'border-box',
        border: `2px solid ${borderColor}`, borderRadius: '2px', background,
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        {children}
        <div style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', marginTop: '3px', fontSize: '11px', color: '#777', lineHeight: 1, whiteSpace: 'nowrap' }}>{toDisplayMm(widthMm)}</div>
      </div>
    </div>
  );

  // Flow figures: take each column's raw solution image and rotate it 90deg ONLY when needed so the long side
  // of its printed/cut area (its layout_dimension) is horizontal — i.e. rotate when that layout_dimension is
  // portrait (taller than wide); if it's already landscape, leave it as-is. Everything is drawn on one shared
  // scale so real proportions are honored (a 1000x700 sheet is bigger than a 700x500). Die-cut green, print blue.
  const flowMaterial = layout_dimension || { width: 0, height: 0 };
  const materialWidthMm = parseFloat(flowMaterial.width) || 0;
  const materialHeightMm = parseFloat(flowMaterial.height) || 0;
  const printingRotate = parseFloat(diecutting_result.printing_result.layout_dimension.height) > parseFloat(diecutting_result.printing_result.layout_dimension.width);
  const dieCuttingRotate = parseFloat(diecutting_result.layout_dimension.height) > parseFloat(diecutting_result.layout_dimension.width);
  const flowMaximumMm = Math.max(
    materialWidthMm, materialHeightMm,
    parseFloat(printingMachineLayoutDimensionInMmWidth) || 0, parseFloat(printingMachineLayoutDimensionInMmHeight) || 0,
    parseFloat(cuttingMachineLayoutDimensionsInMmWidth) || 0, parseFloat(cuttingMachineLayoutDimensionsInMmHeight) || 0
  );
  const flowScale = flowMaximumMm > 0 ? 150 / flowMaximumMm : 0;
  // The solution SVG pads its sheet by 10 units on every side (viewBox "-10 -10 w+20 h+20"), so its drawn sheet
  // is only width/(width+20) of the image. Size the image to the padded sheet and clip, so the visible sheet is
  // exactly its real size at flowScale — matching the padding-free machine rectangle so the two are to scale.
  const SVG_PADDING_MM = 10;
  // The material image is rendered server-side at a fixed orientation (the solution rotates it by its own flag).
  // Its viewBox is the source of truth for the material's real proportions, so we size/rotate the displayed sheet
  // to IT — not to layout_dimension, which can come back transposed and make the image float inside its box.
  const svgViewBoxDimensions = (dataUri) => {
    try {
      const base64 = (dataUri || '').split(',')[1] || '';
      const match = atob(base64.slice(0, 400)).match(/viewBox="-?[\d.]+ -?[\d.]+ ([\d.]+) ([\d.]+)"/);
      if (match) { return { width: parseFloat(match[1]), height: parseFloat(match[2]) }; }
    } catch (error) { /* test stub or malformed data URI — the caller falls back to the layout dimensions */ }
    return null;
  };

  const flowFigure = ({ machineW, machineH, rotate, svgUrl, kind }) => {
    const machineWidthMm = parseFloat(machineW) || 0;
    const machineHeightMm = parseFloat(machineH) || 0;
    if (!flowScale) { return null; }
    const hasMaterial = materialWidthMm > 0 && materialHeightMm > 0;
    const hasMachine = machineWidthMm > 0 && machineHeightMm > 0;
    const color = kind === 'printing' ? '#1565c0' : '#2e7d32';
    const tint = kind === 'printing' ? 'rgba(21, 101, 192, 0.06)' : 'rgba(46, 125, 50, 0.06)';
    // Material proportions + rotation come from the image's own viewBox (the source of truth), falling back to
    // the layout dimensions + the passed rotate flag when the SVG can't be read (e.g. the test stub).
    const viewBox = svgViewBoxDimensions(svgUrl);
    const materialW = viewBox ? viewBox.width - 2 * SVG_PADDING_MM : materialWidthMm;
    const materialH = viewBox ? viewBox.height - 2 * SVG_PADDING_MM : materialHeightMm;
    // Rotate 90deg only when the material is portrait, to put its long side horizontal.
    const displayRotate = viewBox ? materialH > materialW : rotate;
    const displayedWidthMm = displayRotate ? materialH : materialW;
    const displayedHeightMm = displayRotate ? materialW : materialH;
    // The image is sized to its padded viewBox so its drawn sheet fills the box exactly at flowScale.
    const paddedImageWidthPx = (materialW + 2 * SVG_PADDING_MM) * flowScale;
    const paddedImageHeightPx = (materialH + 2 * SVG_PADDING_MM) * flowScale;

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '6px', marginBottom: '16px' }}>
        {hasMaterial && labeledRect({
          widthMm: displayedWidthMm, heightMm: displayedHeightMm,
          widthPx: displayedWidthMm * flowScale, heightPx: displayedHeightMm * flowScale,
          borderColor: 'transparent', background: 'transparent',
          children: (
            // The raw solution image, rotated 90deg only when its printed/cut area's long side is vertical. The
            // image is sized to the padded SVG so the drawn sheet (inside the 10-unit padding) is exactly its real
            // size at flowScale, matching the machine box; the thin empty padding just spills past the box edge.
            // The count text is counter-rotated inside the SVG (count_text_rotate, server-side) so it lands upright.
            <img src={svgUrl} style={{ width: `${paddedImageWidthPx}px`, height: `${paddedImageHeightPx}px`, flexShrink: 0, ...(displayRotate ? { transform: 'rotate(90deg)' } : {}) }} />
          )
        })}
        {hasMachine && (
          <>
            {/* Full feed arrow: a shaft + a triangle head. Top margin clears the material's bottom dimension label. */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '20px 0 12px' }}>
              <div style={{ width: '2px', height: '20px', background: ENTER_EDGE }} />
              <div style={{ width: 0, height: 0, borderLeft: '6px solid transparent', borderRight: '6px solid transparent', borderTop: `9px solid ${ENTER_EDGE}` }} />
            </div>
            {labeledRect({
              widthMm: machineWidthMm, heightMm: machineHeightMm,
              widthPx: machineWidthMm * flowScale, heightPx: machineHeightMm * flowScale,
              borderColor: color, background: tint
            })}
            {/* ALTERNATIVE (shown to compare): the SAME top material image — rotated exactly as the flow shows
                it (count upright) — laid over the machine bed, horizontally centered and sharing the bed's
                bottom edge. A sheet taller than the bed overflows above; its printable bottom sits on the bed. */}
            {hasMaterial && (() => {
              const machineBoxWidthPx = machineWidthMm * flowScale;
              const machineBoxHeightPx = machineHeightMm * flowScale;
              const materialBoxWidthPx = displayedWidthMm * flowScale;
              const materialBoxHeightPx = displayedHeightMm * flowScale;
              return (
                <>
                  <hr style={{ width: '100%', border: 'none', borderTop: '1px solid #eee', margin: '16px 0 8px' }} />
                  <div style={{ fontSize: '10px', color: '#999', marginBottom: '4px' }}>material in machine</div>
                  <div style={{ position: 'relative', width: `${Math.max(machineBoxWidthPx, materialBoxWidthPx)}px`, height: `${Math.max(machineBoxHeightPx, materialBoxHeightPx)}px` }}>
                    {/* the machine bed: horizontally centered, bottom-aligned */}
                    <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: `${machineBoxWidthPx}px`, height: `${machineBoxHeightPx}px`, boxSizing: 'border-box', border: `2px solid ${color}`, borderRadius: '2px', background: tint }} />
                    {/* the top material image (same orientation as the flow above): horizontally centered, sharing the bed's bottom edge */}
                    <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: `${materialBoxWidthPx}px`, height: `${materialBoxHeightPx}px`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <img src={svgUrl} style={{ width: `${paddedImageWidthPx}px`, height: `${paddedImageHeightPx}px`, flexShrink: 0, ...(displayRotate ? { transform: 'rotate(90deg)' } : {}) }} />
                    </div>
                  </div>
                </>
              );
            })()}
          </>
        )}
      </div>
    );
  };

  const printingCard = () => {
    return <div className={styles.layout_column}>
      <div className={styles.layout_column_label}>{t('layouts.layout_type_printing')}</div>

      {/* Flow: this material feeds into the printing machine, the orange edge first. */}
      {flowFigure({
        machineW: printingMachineLayoutDimensionInMmWidth,
        machineH: printingMachineLayoutDimensionInMmHeight,
        rotate: printingRotate,
        svgUrl: printingImageUrl,
        kind: 'printing'
      })}

      {!printing_machine_found && <strong> Makine birim fiyat bulunamadi</strong>}
    </div>
  }

  const diecuttingCard = () => {
    return <div className={styles.layout_column}>
      <div className={styles.layout_column_label}>{t('layouts.layout_type_die_cutting')}</div>

      {/* Flow: this material feeds into the die-cutting machine, the orange edge first. */}
      {flowFigure({
        machineW: cuttingMachineLayoutDimensionsInMmWidth,
        machineH: cuttingMachineLayoutDimensionsInMmHeight,
        rotate: dieCuttingRotate,
        svgUrl: diecuttingImageUrl,
        kind: 'die_cutting'
      })}

      {dieCuttingMachineIdentifier && (
        <div style={{ marginTop: '4px' }}>
          <span className={styles.efficiency_badge}>{dieCuttingMachineIdentifier}</span>
        </div>
      )}

      {!cutting_machine_found && <strong> Makine birim fiyat bulunamadi</strong>}
    </div>
  }


  const card = () => {
    return <div>
      {partTypes.length > 0 && (
        <div className={styles.card_th}>
          {partTypes.join(", ")}, {diecutting_result.member.part_names.join(", ")}
        </div>
      )}

      {/* Real production order: print first (gangs N-up), then split and die-cut. */}
      <div className={styles.layout_columns_container}>
        {printingCard()}
        {diecuttingCard()}
      </div>

      {/* DEBUG (flow spike, admin-only): the raw solution SVGs + raw material dims that the flow figures use. */}
      {window.isAdminShowDebug && (
        <div style={{ marginTop: '12px', borderTop: '1px dashed #ccc', paddingTop: '8px', display: 'flex', gap: '20px', justifyContent: 'center' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '10px', color: '#999', marginBottom: '2px' }}>raw printing image</div>
            {printingImageUrl && <img src={printingImageUrl} style={{ maxWidth: '150px', maxHeight: '150px', border: '1px solid #eee' }} />}
            <div style={{ fontSize: '10px', color: '#c00' }}>svg outer = material: {layout_dimension && `${formatDimension(layout_dimension.width)}×${formatDimension(layout_dimension.height)}`}</div>
            <div style={{ fontSize: '10px', color: '#06c' }}>inner = layout_dimension: {formatDimension(diecutting_result.printing_result.layout_dimension.width)}×{formatDimension(diecutting_result.printing_result.layout_dimension.height)}</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '10px', color: '#999', marginBottom: '2px' }}>raw die-cutting image</div>
            {diecuttingImageUrl && <img src={diecuttingImageUrl} style={{ maxWidth: '150px', maxHeight: '150px', border: '1px solid #eee' }} />}
            <div style={{ fontSize: '10px', color: '#c00' }}>svg outer = material: {layout_dimension && `${formatDimension(layout_dimension.width)}×${formatDimension(layout_dimension.height)}`}</div>
            <div style={{ fontSize: '10px', color: '#06c' }}>inner = layout_dimension: {formatDimension(diecutting_result.layout_dimension.width)}×{formatDimension(diecutting_result.layout_dimension.height)}</div>
          </div>
        </div>
      )}

      {window.isAdminShowDebug && (
        <div style={{ fontSize: '11px', color: '#999', marginTop: '8px', borderTop: '1px solid #eee', paddingTop: '8px' }}>
          <div>{score}</div>
          <div>toplam {kesim_num_total} | toplam {print_num_total}</div>
          <div>Kesim: {cuttingScore} | Baski: {printingScore}</div>
          <div>({calculated_output_dimensions}) | Malzeme: {materialScore}</div>
          {dieCuttingMachineIdentifier && <div>Machine: {dieCuttingMachineIdentifier}</div>}
        </div>
      )}
    </div>
  }

  useEffect( getScore, [ diecutting_result, count] )
  useEffect( () =>  {
    for(let i=0; i < diecutting_result.member.part_types.length; i++) {
      let partType = diecutting_result.member.part_types[i];

      setPartTypes((prev) => {
        const newItem = t("quote_builder.part_type_" + partType);
        return Array.from(new Set([...prev, newItem]));
      });

    }
  }, [ diecutting_result, count] )

  if(score == 0) { return <div key={name} data-score={score}> loading....</div> }

  const hasMissingMachine = !cutting_machine_found || !printing_machine_found;

  // The data behind this card, assembled for the admin JSON viewer. The base64 SVG data URIs are stripped —
  // they are not meaningful as JSON and would bury the dimensions/options the viewer is meant to surface.
  const withoutImageDataUris = (response) => {
    if (!response) {
      return response;
    }
    const placeholder = (value) => (
      typeof value === 'string' && value.startsWith('data:')
        ? `[svg data uri, ${value.length} chars — omitted]`
        : value
    );
    return {
      ...response,
      diecutting_result_image_url: placeholder(response.diecutting_result_image_url),
      printing_result_image_url: placeholder(response.printing_result_image_url),
    };
  };

  const solutionJson = {
    efficiency: efficiency,
    // The sheet the parts are laid out on. The prop is named layout_dimension, but it is the material sheet —
    // distinct from the part's own layout_dimension nested under diecutting_result below.
    material_layout_dimension: layout_dimension,
    // The die-cutting result exactly as the server sent it: the part's layout_dimension, rotate, num_x/num_y,
    // the nested printing_result, margins and machine_dimensions.
    diecutting_result: diecutting_result,
    // Everything the scoring endpoint returned for this solution.
    score_response: withoutImageDataUris(scoreData),
  };

  return (
    <div className={`${styles.combinations_grid_item} ${hasMissingMachine ? 'missing-machine' : ''}`}
      key={name}
      data-score={score}
      data-num-total={numTotal}
      data-num-of-drawing-in-set={numOfDrawingInSet}>

      {efficiency !== null && (
        <span className={styles.efficiency_badge_top_right}>
          {efficiency.toFixed(2)}%
        </span>
      )}

      {diecutting_result.member.part_names && diecutting_result.member.part_names.length > 0 && (
        <div className={styles.part_badges_container}>
          {diecutting_result.member.part_names.map((partName, idx) => (
            <span key={idx} className={styles.efficiency_badge}>{partName.trim()}</span>
          ))}
        </div>
      )}

      {card()}

      {/* Admin-only "View JSON" lives at the very bottom of the card so it sits below the flow figures. */}
      {window.isAdminShowDebug && scoreData && (
        <SolutionJsonViewer data={solutionJson} />
      )}

    </div>
  )
}

export default LayoutNavSectionCombination;
